<template>
  <implement-page type="curtain" />
</template>

<script>
import ImplementPage from "@/views/space/layouts/ImplementPage.vue";

export default {
  name: "SpaceOffice",
  components: {ImplementPage}
};
</script>

<style lang="less" scoped></style>
